import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// INTERFACES
import { LiftType } from "../../../interfaces/Lift.interface";

function FormSelectLiftType({
  inputValue,
  inputOnChange,
}: {
  inputValue: LiftType;
  inputOnChange: (newValue: LiftType) => void;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="col-md-12 mt-3">
      <div className="generalStyles__flex">
        <div className="generalStyles__inputFlexNameLarge">
          <span className="generalStyles__inputFlexRequired">*</span>
          <span>Lift Type</span>
        </div>
        <div className="generalStyles__width100">
          <Select
            className="generalStyles__width100"
            size="small"
            onChange={(e: LiftType) => {
              inputOnChange(e);
            }}
            value={inputValue}
          >
            {[LiftType.ELEVATOR, LiftType.ESCALATOR, LiftType.MOVINGWALK].map((item: LiftType) => (
              <Option key={item} value={item}>
                {LiftType[item]}
              </Option>
            ))}
          </Select>
        </div>
        <div className="generalStyles__infoTooltipIconBlank" />
      </div>
    </div>
  );
}

export default FormSelectLiftType;
